import React, { Component,useEffect, useState } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import Dialog from '../../../../commonModules/interface/Dialog';
import { isEmpty } from "lodash";
import TechAnalys from './Forms/TechAnalys';
import NewRepairAction from './Forms/NewRepairAction';
import TransfertStockOccasion from './Forms/TransfertStockOccasion'
import GlobalAnalys from './Forms/GlobalAnalys';
import { toast } from 'react-toastify';

import { Box, Drawer, Grid, Button, IconButton, List, ListItem,  ListItemIcon,  Paper, Typography, Fab, Tooltip } from '@material-ui/core';
import { StorefrontRounded, AddRounded, AssignmentRounded, TextRotateUp, BuildRounded, InfoRounded, DeleteSweepRounded, FindInPageRounded, Settings, SettingsSystemDaydreamRounded} from '@material-ui/icons';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';
import AddInBin from '../Recycling/AddInBin';
import CardButton from '../../../../commonModules/interface/CardButton';
import { amber, blue, green, pink, purple, red } from '@material-ui/core/colors';

// import { List, ListItem, ListItemIcon } from '@material-ui/core';


const UpdateSAV = (props) => {
    const initState = {
        form: "",
        comments: "",
        price: "",
        files:[],
        formData:{},
        next_status:"",
        next_status_display:"",
        formID:"",
        formID_display:"",
        openSpeedDial: false,
        openOptions: false,
        action_audio: null,
    }
    const actions = {
        "global": { icon: <FindInPageRounded style={{ color: amber[300]}} fontSize="large" />, title: "Analyse Globale" },
        "info": { icon: <InfoRounded style={{ color: amber[300]}} fontSize="large" />, title: "Information complémentaire" },
        "change_store": { icon: <StorefrontRounded style={{ color: amber[300]}} fontSize="large" />, title: "Changement de magasin" },
        "reinstall": { icon: <TextRotateUp style={{ color: amber[300]}} fontSize="large" />, title: "Reinstallation" },
        "resell": { icon: <TextRotateUp style={{ color: amber[300]}} fontSize="large" />, title: "Revente" },
        "tech": { icon: <AssignmentRounded style={{ color: green[300]}} fontSize="large" />, title: "Analyse Technique" },
        "in_repair": { icon: <BuildRounded style={{ color: blue[300]}} fontSize="large" />, title: "Action de réparation" },
        "add_in_bin": { icon: <DeleteSweepRounded style={{ color: red[300]}} fontSize="large" />, title: "Jeter" }
    }
    const [state, setState] = useState(initState);
    const [list,setList] =useState(['global', 'tech','change_store']);

    useEffect(() => {
        props.fetchSchemas()
    }, []);

    useEffect(()=>{
        let list = ['global', 'tech','change_store']

        if (props.sav.sav_last_status === "IN_REPAIR") {
            list = ['in_repair','info','change_store']
        } else if ( props.sav.sav_last_status === "HS") {
            list = ['add_in_bin','info','change_store','resell']
        }else if ( props.sav.sav_last_status === "REPAIRED") {
            list = ['info','reinstall','resell','change_store']
        }else{
            console.log('LASSTER STATUS ',props.sav.sav_last_status)
        }
        setList(list)
    }, [props.sav.sav_last_status]);

    const setFiles = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        setState(prevState => ({...prevState,
            files:list
        }))
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({...prevState,
            [name]: value
        }))
    }
    const handleSelect = (option, name) => {
        let value = option.value
        let displayName = name +'_display'
        setState(prevState => ({...prevState,
            [name]:value,
            [displayName]:option,
        }))
    }
    const handleSubmit = async () => {
        try {
            let formData = isEmpty(state.formData) ? null : JSON.stringify(state.formData)

            let data = {
                action_type: state.form,
                action_ts: new Date(),
                action_status: state.next_status || props.sav.sav_last_status,
                action_comment: state.comments,
                action_form: formData,
                action_price: parseFloat(state.price || 0),
                action_sav_id: props.sav.id,
                action_files: state.files
            }
            if (state.action_audio) {
                data.action_audio = state.action_audio;
            }
            const req = await fetch("/sav/updateSAV",{
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data,
                }),
                credentials: 'same-origin',
            })
            let res = await req.json()
            console.log("[DEBUG],repair,",{res})
            if (res.error || res.errorCode) {
                toast.error("ERROR "+res.error)
    
                console.log('====================================');
                console.log("[ERROR]", res.error);
                console.log('====================================');
            } else {
                toast.success("SUCCESS")
                console.log('====================================');
                console.log("[SUCCESS] HANDLE REPAIR");
                console.log('====================================');
                props.updateSav()
                props.closePopup()
            }
            
        } catch (error) {
            toast.error("BIG_ERROR handleSubmit error ")

            console.log('====================================');
            console.log("[ERROR]", error);
            console.log('====================================');
        }
        
    }
    const closeForms = () => {
        setState(initState)
    }
    const submitForm = (formData) => {
        console.log('===========SUBMIT FORM=========================');
        console.log({formData});
        console.log('====================================');
        setState(prevState => ({...prevState, formData }))
    }

    const handleTranscription = (result) => {
        const text = (result.speakerCount <= 1)
            ? (result.transcript || '')
            : (result.summary || result.transcript || '');
        setState(prevState => ({...prevState,
            comments: text,
            action_audio: {
                audioId: result.audioId,
                transcript: result.transcript || '',
                summary: result.summary || null,
                // storehouse stocke l'action telle quelle : borne inline à 40 segments
                // (AC-PII-1), le dialogue complet reste dans le sidecar audioList domainModel
                segments: (result.segments || []).slice(0, 40),
                speakerCount: result.speakerCount || 0,
                language: result.language || ''
            }
        }));
    }
        
        
        return (
            <Box p={1}>
                {state.form === "in_repair" &&
                    <NewRepairAction
                        {...props}
                        {...state}
                        handleChange={handleChange}
                        setFiles={setFiles}
                        submitAll={handleSubmit}
                        handleSelect={handleSelect}
                        closeForms={closeForms}
                        handleTranscription={handleTranscription}
                    />
                }
                {state.form === "global" &&
                    <GlobalAnalys
                        {...props}
                        {...state}
                        closeForms={closeForms}
                        handleChange={handleChange}
                        setFiles={setFiles}
                        submitAll={handleSubmit}
                        handleTranscription={handleTranscription}
                    />
                }
                {state.form === "info" &&
                    <GlobalAnalys
                        {...props}
                        {...state}
                        closeForms={closeForms}
                        handleChange={handleChange}
                        setFiles={setFiles}
                        submitAll={handleSubmit}
                        handleTranscription={handleTranscription}
                    />
                }
                {state.form === "tech" && 
                    <TechAnalys 
                        {...props} 
                        {...state} 
                        closeForms={closeForms}
                        handleChange={handleChange} 
                        handleSelect={handleSelect} 
                        setFiles={setFiles} 
                        submitForm={submitForm} 
                        submitAll={handleSubmit} 
                    />
                }
                {state.form === "change_store" && 
                    <TransfertStockOccasion
                        closeForms={closeForms}
                        submitAll={handleSubmit} 
                        handleChange={handleChange} 
                        {...props}
                    />
                }
                {state.form === "reinstall" && 
                    <AddInBin
                        closeForms={closeForms}
                        SAV={props.sav}
                        {...props}
                    />
                }
                {state.form === "resell" && 
                    <AddInBin
                        closeForms={closeForms}
                        SAV={props.sav}
                        {...props}
                    />
                }
                {state.form === "add_in_bin" && 
                    <AddInBin
                        closeForms={closeForms}
                        SAV={props.sav}
                        {...props}
                    />
                }

                {state.openOptions &&
                    <Dialog
                        title="Options"
                        block={true}
                        close={() => setState(prevState => ({...prevState, 
                            openOptions: false,
                        })) }
                    >
                        {list.map(action =>
                            <CardButton
                                action={() => setState(prevState => ({...prevState, form: action}))}
                                icon={actions[action].icon}
                                title={actions[action].title}
                            />
                        )}
                    </Dialog>
                }

                <Fab onClick={() => setState(prevState => ({...prevState, openOptions: true }))} color="primary">
                    <AddRounded />
                </Fab>
                <Box p={1} />
            </Box>
        );
}

export default UpdateSAV;








